import React from "react";
import { PanelHelp } from "./QuickStart";
import { ChevronDown } from "lucide-react";

const monoStyle = {
  fontFamily: "'JetBrains Mono', ui-monospace, monospace",
};

/**
 * Reusable collapsible wrapper matching the Late Money / Exacta
 * Overlays sections. `open` is controlled by the parent so other
 * actions (e.g. clicking a banner chip) can force-open the section.
 */
export const CollapsibleSection = ({
  title,
  icon: Icon,
  badge,
  open,
  onToggle,
  testId,
  helpStep,
  children,
}) => {
  return (
    <section
      className="rounded-lg border border-stone-800 bg-[#0e0e0e] mt-5 overflow-hidden"
      data-testid={testId}
    >
      <button
        type="button"
        onClick={onToggle}
        className="w-full flex items-center justify-between gap-3 px-5 py-3 border-b border-stone-800 hover:bg-[#141414]"
        data-testid={`${testId}-toggle`}
      >
        <div className="flex items-center gap-2 text-[#f5ecd6]">
          {Icon && <Icon size={16} className="text-[#84cc16]" />}
          <span className="text-sm uppercase tracking-[0.2em]" style={monoStyle}>
            {title}
          </span>
          {helpStep && <PanelHelp step={helpStep} label={title} />}
          {badge}
        </div>
        <span
          className="text-[10px] uppercase tracking-[0.2em] text-stone-400 inline-flex items-center gap-1"
          style={monoStyle}
        >
          {open ? "Hide" : "Show"}
          <ChevronDown
            size={14}
            className={`transition-transform ${open ? "rotate-180" : ""}`}
          />
        </span>
      </button>
      {open && <div className="p-4">{children}</div>}
    </section>
  );
};
